import { inject } from '@angular/core';

import { Logger, WindowRef } from '@frontend/vanilla/core';

import { BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE, VIEW_TRANSITION_LOG_TAG as LOG_TAG } from '../../view-transition.constants';
import { BrowserBackDetectionStrategy } from './browser-back-detection.strategy.model';

export class NavigationApiBackDetectionStrategy implements BrowserBackDetectionStrategy {
    private logger = inject(Logger);
    private navigation = inject(WindowRef).nativeWindow.navigation;
    private previousNavigationHistoryEntry: NavigationHistoryEntry | undefined = undefined;

    init(): this {
        this.listenForCurrentEntryChanges();

        return this;
    }

    isBrowserBackNavigation(): boolean {
        const currentIndex = this.navigation.currentEntry?.index;
        const previousIndex = this.previousNavigationHistoryEntry?.index;

        if (!currentIndex || !previousIndex) {
            return false;
        }

        const isBrowserBackNavigation = currentIndex < previousIndex;

        if (isBrowserBackNavigation) {
            this.logger.info(`${LOG_TAG} ${BROWSER_BACK_NAVIGATION_DETECTED_MESSAGE}`);
        }

        return isBrowserBackNavigation;
    }

    private listenForCurrentEntryChanges(): void {
        this.navigation.oncurrententrychange = (event: NavigationCurrentEntryChangeEvent) => {
            if (event.navigationType === 'traverse') {
                this.previousNavigationHistoryEntry = event.from;
            }
        };
    }
}
